import React from 'react'
import { connect } from 'react-redux'
import { useParams } from 'react-router-dom'

import { acceptRequest, checkRequestExists, rejectRequest } from '../actions/parentPortal'
import { browserHistory } from '../Routes'
import { useInitDispatch } from '../util/hooks'

const ParentRequest = ({ requestInfo, acceptRequest, rejectRequest }) => {
  const params = useParams()

  useInitDispatch(checkRequestExists(params.code), [params.code])

  const outputRequest = () => {
    return (
      <div>
        <p>
          {requestInfo.user.firstName} {requestInfo.user.lastName} has requested to share
          their work with you.
        </p>
        <p>
          By accepting this request, you will be able to see the activities they perform,
          discussion topics around those points, and the ability to message directly in
          the system with them.
        </p>
        <div className="nav">
          <button
            onClick={() => acceptRequest(requestInfo.request.requestCode)}
            className="btn btn-success">
            Accept Request
          </button>
          <button
            onClick={() => rejectRequest(requestInfo.request.requestCode)}
            className="btn btn-danger">
            Reject Request
          </button>
        </div>
      </div>
    )
  }
  const outputNoRequest = () => {
    return <div>No Request</div>
  }

  if (requestInfo && requestInfo.request) {
    return outputRequest()
  }

  return outputNoRequest()
}

export default connect(
  state => {
    return {
      ...state.parentRequest
    }
  },
  dispatch => {
    return {
      acceptRequest: r =>
        dispatch(acceptRequest(r)).then(() => browserHistory.replace('/parent')),
      rejectRequest: r =>
        dispatch(rejectRequest(r)).then(() => browserHistory.replace('/'))
    }
  }
)(ParentRequest)
